/* eslint-disable space-before-function-paren */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'jquery'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Viewer.setDefaults({
    url: 'data-source', // 大图地址参数
    title: false,
    zoomRatio: 0.5,
    filter(image) {
        // 只有大图的才能放大
        const dataSource = image.getAttribute('data-source')
        if (dataSource == null || dataSource == undefined) {
            return false
        } else {
            return true
        }
    }
})
Vue.use(Viewer)

new Vue({
    router,
    render: h => h(App)
        // eslint-disable-next-line eol-last
}).$mount('#app')